// Cartões de KPI em degradê — o mesmo estilo no dashboard (MetricTile) e na vida do agente (página e
// modal), definido pelo dono em 2026-09-15. Só tokens: o "branco" e o "preto" das misturas vêm de
// --kpi-foreground e --kpi-ink, nunca de literal.

const KPI_NEUTRAL = "hsl(var(--kpi-neutral))";

// Degradê a 135° do acento clareado → acento → levemente escurecido, com brilho no canto superior
// direito. Sem suporte a color-mix, o navegador fica com a cor sólida de backgroundColor.
export function kpiGradientStyle(accent, ink = "light") {
  const base = accent || KPI_NEUTRAL;
  return {
    backgroundColor: base,
    backgroundImage: [
      "radial-gradient(circle at 100% 0%, hsl(var(--kpi-foreground) / 0.24), transparent 55%)",
      `linear-gradient(135deg, color-mix(in srgb, ${base} 82%, hsl(var(--kpi-foreground))) 0%, ${base} 55%, color-mix(in srgb, ${base} 86%, hsl(var(--kpi-ink))) 100%)`,
    ].join(", "),
    textShadow: ink === "dark" ? "none" : "0 1px 2px hsl(var(--kpi-ink) / 0.3)",
  };
}

// Texto branco por padrão; ink="dark" (texto #171717, sem sombra) para acento claro como o amarelo.
export function kpiInkClasses(ink = "light") {
  const dark = ink === "dark";
  return {
    root: dark ? "text-kpi-ink" : "text-kpi-foreground",
    label: dark ? "text-kpi-ink/80" : "text-kpi-foreground/90",
    helper: dark ? "text-kpi-ink/75" : "text-kpi-foreground/85",
    icon: dark ? "text-kpi-ink/85" : "text-kpi-foreground/90",
    // Etiqueta de comparação sobre o degradê: translúcida, na cor do texto. A seta indica a direção.
    pill: dark ? "border-transparent bg-kpi-ink/15 text-kpi-ink" : "border-transparent bg-kpi-foreground/20 text-kpi-foreground",
  };
}

// Cor do cartão pelo rótulo, igual ao cartão equivalente do dashboard. A ordem importa: os rótulos
// específicos ("contratos aprovados") vêm antes do genérico ("contratos").
const LABEL_ACCENTS = [
  ["bruta", "var(--chart-1)"],
  ["liquida", "var(--chart-2)"],
  ["comissionada", "var(--chart-3)"],
  ["repasse", "var(--chart-4)"],
  ["spread", "var(--chart-5)"],
  ["aprovados", "hsl(var(--badge-success))"],
  ["cancelados", "hsl(var(--badge-danger))"],
  ["negados", "hsl(var(--sidebar-primary))", "dark"],
  ["andamento", "var(--chart-1)"],
  ["contratos", "var(--chart-4)"],
  // "Total digitado": o bloco Contratos passou a se chamar Digitação em 2026-09-15.
  ["digita", "var(--chart-4)"],
];

export function kpiAccentByLabel(label) {
  const text = String(label || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();
  const match = LABEL_ACCENTS.find(([key]) => text.includes(key));
  return match ? { accent: match[1], ink: match[2] || "light" } : { accent: KPI_NEUTRAL, ink: "light" };
}

// Etiqueta de comparação sólida, no verde e vermelho das tags (StatusBadge): lê sobre qualquer cor de
// cartão. lowerIsBetter inverte a leitura onde subir é ruim (cancelados, negados): alta vira vermelho.
export function kpiComparisonToneClass(change, { lowerIsBetter = false } = {}) {
  const hasDirection = change?.percent != null && (change.direction === "up" || change.direction === "down");
  if (!hasDirection) return "bg-badge-neutral text-badge-neutral-foreground";
  const improved = lowerIsBetter ? change.direction === "down" : change.direction === "up";
  return improved ? "bg-badge-success text-badge-foreground" : "bg-badge-danger text-badge-foreground";
}
